<!--
 * @Author: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description: 饼图
-->
<script>
import ChartBase from '../base.vue';
/******* echarts *********/
import * as echarts from 'echarts/core';
import { TitleComponent, DatasetComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { isEmpty } from 'lodash';

echarts.use([
  TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout
]);

export default {
  name: 'LcChartPie',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__pie']
    };
  },
  created() {
    // preset
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;
      if (!isEmpty(options)) {
        data.forEach(item => {
          item['name'] = item[options?.dimension];
          item['value'] = item[options?.valueMap];
        });
      }

      this.chartData = data;
    }
  }
};
</script>
